export const STATE_AUTHENTICATING = 'authenticating';
export const STATE_PROCESSING = 'processing';
export const STATE_FAIL = 'fail';
export const STATE_SUCCESS = 'success';
export const STATE_RESET = 'reset';